import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import PageLoader from "components/PageLoader";

const LazyIssuedCard = lazy(() => import('pages/IssuedCard'));
const LazyIssuedCardList = lazy(() => import('pages/IssuedCardList'));

function IssuedCardRoute() {
  return (
    <Suspense fallback={<PageLoader />}>
      <Routes>
        <Route path="/" element={<LazyIssuedCard />} />
        <Route path="/:issued_card_id" element={<LazyIssuedCardList />} />
      </Routes>
    </Suspense>
  );
}

export default IssuedCardRoute;
